import { MessageDescriptor } from 'react-intl'

import {
  eapToHpi0SessionLeftAddHpiLinkText,
  eapToHpi0SessionLeftAddPaymentLinkText,
  eapToHpi0SessionLeftDependentDescriptionText,
  eapToHpi0SessionLeftDependentViewCostLinkText,
  eapToHpi0SessionLeftSelfDescriptionText,
  eapToHpi0SessionLeftSelfViewCostLinkText,
  eapToHpi1SessionLeftDependentAddHpiLinkText,
  eapToHpi1SessionLeftDependentAddPaymentLinkText,
  eapToHpi1SessionLeftDependentDescriptionText,
  eapToHpi1SessionLeftSelfAddHpiLinkText,
  eapToHpi1SessionLeftSelfAddPaymentLinkText,
  eapToHpi1SessionLeftSelfDescriptionText,
  eapToHpi1SessionLeftViewCostLinkText,
} from '../messages'

interface UseGetEapToHpiEligibilityTextProps {
  dependentsName?: string
  sessionsRemaining: number
  hasHpi: boolean
  hasPaymentInfo: boolean
}

export enum EAP_TO_HPI_LINK_DESTINATION {
  ADD_HPI,
  ADD_PAYMENT,
  VIEW_COST,
}

export const useGetEapToHpiEligibilityText = (props: UseGetEapToHpiEligibilityTextProps) => {
  const { hasHpi, hasPaymentInfo, sessionsRemaining, dependentsName } = props
  let descriptionText: MessageDescriptor
  let linkText: MessageDescriptor
  let linkDestination: EAP_TO_HPI_LINK_DESTINATION

  if (dependentsName && sessionsRemaining === 1) {
    // Dependent / 1 session remaining messaging
    descriptionText = eapToHpi1SessionLeftDependentDescriptionText
    if (!hasHpi) {
      linkText = eapToHpi1SessionLeftDependentAddHpiLinkText
      linkDestination = EAP_TO_HPI_LINK_DESTINATION.ADD_HPI
    } else if (!hasPaymentInfo) {
      linkText = eapToHpi1SessionLeftDependentAddPaymentLinkText
      linkDestination = EAP_TO_HPI_LINK_DESTINATION.ADD_PAYMENT
    } else {
      linkText = eapToHpi1SessionLeftViewCostLinkText
      linkDestination = EAP_TO_HPI_LINK_DESTINATION.VIEW_COST
    }
  } else if (dependentsName && sessionsRemaining === 0) {
    // Dependent / 0 session remaining messaging
    descriptionText = eapToHpi0SessionLeftDependentDescriptionText
    if (!hasHpi) {
      linkText = eapToHpi0SessionLeftAddHpiLinkText
      linkDestination = EAP_TO_HPI_LINK_DESTINATION.ADD_HPI
    } else if (!hasPaymentInfo) {
      linkText = eapToHpi0SessionLeftAddPaymentLinkText
      linkDestination = EAP_TO_HPI_LINK_DESTINATION.ADD_PAYMENT
    } else {
      linkText = eapToHpi0SessionLeftDependentViewCostLinkText
      linkDestination = EAP_TO_HPI_LINK_DESTINATION.VIEW_COST
    }
  } else if (!dependentsName && sessionsRemaining === 1) {
    // Self / 1 session remaining messaging
    descriptionText = eapToHpi1SessionLeftSelfDescriptionText
    if (!hasHpi) {
      linkText = eapToHpi1SessionLeftSelfAddHpiLinkText
      linkDestination = EAP_TO_HPI_LINK_DESTINATION.ADD_HPI
    } else if (!hasPaymentInfo) {
      linkText = eapToHpi1SessionLeftSelfAddPaymentLinkText
      linkDestination = EAP_TO_HPI_LINK_DESTINATION.ADD_PAYMENT
    } else {
      linkText = eapToHpi1SessionLeftViewCostLinkText
      linkDestination = EAP_TO_HPI_LINK_DESTINATION.VIEW_COST
    }
  } else {
    // Self / 0 session remaining messaging
    descriptionText = eapToHpi0SessionLeftSelfDescriptionText
    if (!hasHpi) {
      linkText = eapToHpi0SessionLeftAddHpiLinkText
      linkDestination = EAP_TO_HPI_LINK_DESTINATION.ADD_HPI
    } else if (!hasPaymentInfo) {
      linkText = eapToHpi0SessionLeftAddPaymentLinkText
      linkDestination = EAP_TO_HPI_LINK_DESTINATION.ADD_PAYMENT
    } else {
      linkText = eapToHpi0SessionLeftSelfViewCostLinkText
      linkDestination = EAP_TO_HPI_LINK_DESTINATION.VIEW_COST
    }
  }

  return {
    descriptionText,
    linkText,
    linkDestination,
  }
}
